import { AxiosError } from 'axios'
import { computed, flow, makeObservable, toJS } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils'

import { UrlParams } from 'Portals/Customer/constants'
import { Audit } from 'Portals/Customer/entities'
import {
	getFilterConfig,
	getMainSearchConfig
} from 'Portals/Customer/Pages/Audit/TableList/Filters/utils'
import { AuditRepo } from 'Portals/Customer/repositories'

import { RootStore } from '../rootStore/RootStore'

const STORAGE_AUDIT_PAGE_SIZE = storagePageSizeConstant('auditTable')

export class AuditTable extends TableStore<Audit.Basic> {
	constructor(private rootStore: RootStore) {
		super(STORAGE_AUDIT_PAGE_SIZE)
	}

	@computed
	get auditData() {
		return toJS(this.items)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				defaultSort,
				repository: AuditRepo.getList
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [
			UrlParams.serviceSiteId,
			UrlParams.locationName,
			UrlParams.createdUserId,
			UrlParams.updatedUserId,
			UrlParams.exportCode,
			CoreUrlParams.searchQuery
		]

		const filterKeys = [
			UrlParams.createDateFrom,
			UrlParams.createDateTo,
			UrlParams.updateDateFrom,
			UrlParams.updateDateTo,
			UrlParams.isUpdatedOnly,
			UrlParams.isExceedThreshold,
			UrlParams.kpiId,
			UrlParams.kpiCategoryId
		]

		const mergedSearchConfig = {
			...getMainSearchConfig(),
			...searchQueryConfig
		}

		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, getFilterConfig())
	}
}
